import React from 'react';
import { useT } from '../utils/i18n';
import '../App.css'; // Make sure App.css has spinner styles

const LoadingSpinner = ({ small = false }) => {
  const t = useT();
  const sizeClass = small ? 'spinner-border-sm' : '';
  return (
    <div className={`spinner-border ${sizeClass}`} role="status">
      <span className="visually-hidden">{t('Loading...')}</span>
    </div>
  );
};

export default LoadingSpinner;